// extracted by mini-css-extract-plugin
module.exports = {"mobileAttendeesWrapper":"MobileAttendees_mobileAttendeesWrapper__18Ti3"};